import { CheckboxItem } from 'components/core/checkbox-group';

import { NewsOverviewFieldsFragment } from 'api/graphql-types';
import { useAppSelector } from 'redux/store';
import { IFilters } from 'components/filter-sidebar';
import { useTheme } from 'utils/hooks/queries';

const useNewsFilters = (module: NewsOverviewFieldsFragment, onChange: (themeIds: string[]) => void): IFilters => {
	const { selectedThemes, setSelectedThemesParam } = useTheme();
	const { themes } = useAppSelector((state) => state.themes);

	const themesFilter = {
		id: 'selectedThemes',
		type: 'checkbox',
		title: module.filterLabel || '',
		onChange: (items: CheckboxItem[], active: boolean): void => {
			if (active) {
				const mergedThemes = [...selectedThemes, ...items];
				setSelectedThemesParam(mergedThemes);
				onChange(mergedThemes.map((item) => String(item.id)));
			} else {
				const itemIds = new Set(items.map((newItem) => newItem.id));
				const newThemes = selectedThemes.filter((selectedItem) => !itemIds.has(selectedItem.id));
				setSelectedThemesParam(newThemes);
				onChange(newThemes.map((item) => String(item.id)));
			}
		},
		value: selectedThemes,
		options: themes?.map((theme) => ({
			id: Number(theme.id),
			label: theme?.attributes?.title
		})) as CheckboxItem[]
	};

	return [themesFilter] as IFilters;
};

export default useNewsFilters;
